import './App.css';
import React, { Fragment } from "react";
import { BrowserRouter, Routes, Route} from "react-router-dom";
import store, { persistor } from "./store/index.ts";
import authSlice from "./store/slices/auth.ts";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import ProtectedRoute from "./routes/ProtectedRoute";
import { useState } from 'react';

import EmailCapture from './components/emailCapture';
import Home from './views/home';
import Blog from './views/blog';
import BlogDetail from './views/blogDetail';
import About from './views/about';
import Contact from './views/contact';
import CookiePolicy from './views/cookie-policy';

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <BrowserRouter>
          <Routes>
            <Fragment>
              <Route exact path="/info" element={<EmailCapture />} />
              <Route exact path="/" element={<Home />} />
              <Route exact path="/blog" element={<Blog />} />
              <Route exact path="/blog-detail" element={<BlogDetail />} />
              <Route exact path="/about" element={<About />} />
              <Route exact path="/contact" element={<Contact />} />
              <Route exact path="/cookie-policy" element={<CookiePolicy />} />
            </Fragment>
          </Routes>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
